module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-77.de634299.svg";